"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _mediaPipeUtils = _interopRequireDefault(require("../../util/mediaPipeUtils"));
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var mediaPipeUtils = _mediaPipeUtils["default"].getInstance();
Entry.AI_UTILIZE_BLOCK.gestureRecognition = {
  name: 'gestureRecognition',
  imageName: 'gestureRecognition.svg',
  category: 'video',
  title: {
    ko: '손 인식',
    en: 'Gesture Recognition'
  },
  titleKey: 'Workspace.gesture_recognition_title_text',
  description: Lang.Msgs.ai_utilize_gesture_recognition_description,
  descriptionKey: 'Msgs.ai_utilize_gesture_recognition_description',
  isInitialized: false,
  init: function init() {
    return (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee() {
      return _regenerator["default"].wrap(function (_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.next = 1;
            return mediaPipeUtils.initialize();
          case 1:
            Entry.AI_UTILIZE_BLOCK.gestureRecognition.isInitialized = true;
          case 2:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }))();
  },
  destroy: function destroy() {
    mediaPipeUtils.destroy();
    Entry.AI_UTILIZE_BLOCK.gestureRecognition.isInitialized = false;
  }
};
Entry.AI_UTILIZE_BLOCK.gestureRecognition.getBlocks = function () {
  var params = {
    getEventIndicator: function getEventIndicator() {
      return {
        type: 'Indicator',
        img: 'block_icon/start_icon_hand.svg',
        size: 14,
        position: {
          x: 0,
          y: -2
        }
      };
    },
    getCommonIndicator: function getCommonIndicator() {
      return {
        type: 'Indicator',
        img: 'block_icon/ai_hand_icon.svg',
        size: 11
      };
    },
    getHandNumber: function getHandNumber() {
      return {
        type: 'Dropdown',
        options: [['1', 0], ['2', 1]],
        value: 0,
        fontSize: 11,
        bgColor: EntryStatic.colorSet.block.darken.AI_UTILIZE,
        arrowColor: EntryStatic.colorSet.common.WHITE
      };
    },
    getHand: function getHand() {
      return {
        type: 'Dropdown',
        options: [[Lang.Blocks.right_hand, 'Left'], [Lang.Blocks.left_hand, 'Right']],
        value: 'Left',
        fontSize: 11,
        bgColor: EntryStatic.colorSet.block.darken.AI_UTILIZE,
        arrowColor: EntryStatic.colorSet.common.WHITE
      };
    },
    getGesture: function getGesture() {
      return {
        type: 'Dropdown',
        options: [[Lang.gesture_list.closed_fist, 'Closed_Fist'], [Lang.gesture_list.open_palm, 'Open_Palm'], [Lang.gesture_list.pointing_up, 'Pointing_Up'], [Lang.gesture_list.thumb_down, 'Thumb_Down'], [Lang.gesture_list.thumb_up, 'Thumb_Up'], [Lang.gesture_list.victory, 'Victory'], [Lang.gesture_list.iloveyou, 'ILoveYou']],
        value: 'Closed_Fist',
        fontSize: 11,
        bgColor: EntryStatic.colorSet.block.darken.AI_UTILIZE,
        arrowColor: EntryStatic.colorSet.common.WHITE
      };
    },
    getHandPoint: function getHandPoint() {
      return {
        type: 'Dropdown',
        options: [[Lang.Blocks.thumb, 1], [Lang.Blocks.index_finger, 5], [Lang.Blocks.middle_finger, 9], [Lang.Blocks.ring_finger, 13], [Lang.Blocks.little_finger, 17], [Lang.Blocks.wrist, 0]],
        value: 1,
        fontSize: 11,
        bgColor: EntryStatic.colorSet.block.darken.AI_UTILIZE,
        arrowColor: EntryStatic.colorSet.common.WHITE,
        dropdownSync: 'handPoint'
      };
    },
    getHandDetailPoint: function getHandDetailPoint() {
      return {
        type: 'DropdownDynamic',
        menuName: function menuName() {
          var handPoint = this.getTargetValue('handPoint');
          var value = this.getValue();
          if (handPoint === 1) {
            if (![2, 3].includes(value)) {
              this.setValue(3);
            }
            return [[Lang.Blocks.tip, 3], [Lang.Blocks.dip, 2]];
          } else if (handPoint !== 0) {
            if (![1, 2, 3].includes(value)) {
              this.setValue(3);
            }
            return [[Lang.Blocks.tip, 3], [Lang.Blocks.dip, 2], [Lang.Blocks.pip, 1]];
          } else {
            this.setValue(0);
            return [[Lang.Blocks.none, 0]];
          }
        },
        needDeepCopy: true,
        fontSize: 11,
        bgColor: EntryStatic.colorSet.block.darken.AI_UTILIZE,
        arrowColor: EntryStatic.colorSet.common.WHITE
      };
    },
    getAxis: function getAxis() {
      return {
        type: 'Dropdown',
        options: [['x', 'x'], ['y', 'y']],
        value: 'x',
        fontSize: 11,
        bgColor: EntryStatic.colorSet.block.darken.AI_UTILIZE,
        arrowColor: EntryStatic.colorSet.common.WHITE
      };
    },
    getStartStop: function getStartStop() {
      return {
        type: 'Dropdown',
        options: [[Lang.Blocks.video_start, 'start'], [Lang.Blocks.video_end, 'stop']],
        value: 'start',
        fontSize: 11,
        bgColor: EntryStatic.colorSet.block.darken.AI_UTILIZE,
        arrowColor: EntryStatic.colorSet.common.WHITE
      };
    },
    getShowHide: function getShowHide() {
      return {
        type: 'Dropdown',
        options: [[Lang.Blocks.video_show_video, 'show'], [Lang.Blocks.video_hide_video, 'hide']],
        value: 'show',
        fontSize: 11,
        bgColor: EntryStatic.colorSet.block.darken.AI_UTILIZE,
        arrowColor: EntryStatic.colorSet.common.WHITE
      };
    }
  };
  return {
    hand_detection_title: {
      skeleton: 'basic_text',
      color: EntryStatic.colorSet.common.TRANSPARENT,
      params: [{
        type: 'Text',
        text: Lang.Blocks.hand_detection_title_text,
        color: EntryStatic.colorSet.common.TEXT,
        align: 'center'
      }],
      def: {
        type: 'hand_detection_title'
      },
      "class": 'hand',
      isNotFor: ['gestureRecognition'],
      events: {}
    },
    when_hand_detection: {
      color: EntryStatic.colorSet.block["default"].AI_UTILIZE,
      outerLine: EntryStatic.colorSet.block.darken.AI_UTILIZE,
      skeleton: 'basic_event',
      statements: [],
      params: [params.getEventIndicator()],
      events: {},
      def: {
        params: [null],
        type: 'when_hand_detection'
      },
      paramsKeyMap: {
        VALUE: 0
      },
      event: 'when_hand_detection',
      "class": 'hand',
      isNotFor: ['gestureRecognition'],
      func: function func(sprite, script) {
        return script.callReturn();
      },
      wikiClass: 'ai_utilize_gesture'
    },
    hand_detection: {
      color: EntryStatic.colorSet.block["default"].AI_UTILIZE,
      outerLine: EntryStatic.colorSet.block.darken.AI_UTILIZE,
      skeleton: 'basic',
      statements: [],
      params: [params.getStartStop(), params.getCommonIndicator()],
      events: {},
      def: {
        type: 'hand_detection'
      },
      paramsKeyMap: {
        VALUE: 0
      },
      "class": 'hand',
      isNotFor: ['gestureRecognition'],
      func: function func(sprite, script) {
        return (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee2() {
          var value;
          return _regenerator["default"].wrap(function (_context2) {
            while (1) switch (_context2.prev = _context2.next) {
              case 0:
                value = script.getField('VALUE');
                if (mediaPipeUtils.isInitialized) {
                  _context2.next = 1;
                  break;
                }
                _context2.next = 1;
                return mediaPipeUtils.initialize();
              case 1:
                if (!(value === 'start')) {
                  _context2.next = 3;
                  break;
                }
                _context2.next = 2;
                return mediaPipeUtils.startHandGestureRecognition(value);
              case 2:
                _context2.next = 4;
                break;
              case 3:
                _context2.next = 4;
                return mediaPipeUtils.stopHandGestureRecognition(value);
              case 4:
                return _context2.abrupt("return", script.callReturn());
              case 5:
              case "end":
                return _context2.stop();
            }
          }, _callee2);
        }))();
      },
      wikiClass: 'ai_utilize_gesture'
    },
    draw_detected_hand: {
      color: EntryStatic.colorSet.block["default"].AI_UTILIZE,
      outerLine: EntryStatic.colorSet.block.darken.AI_UTILIZE,
      skeleton: 'basic',
      statements: [],
      params: [params.getShowHide(), params.getCommonIndicator()],
      events: {},
      def: {
        type: 'draw_detected_hand'
      },
      paramsKeyMap: {
        VALUE: 0
      },
      "class": 'hand',
      isNotFor: ['gestureRecognition'],
      func: function func(sprite, script) {
        return (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee3() {
          var value;
          return _regenerator["default"].wrap(function (_context3) {
            while (1) switch (_context3.prev = _context3.next) {
              case 0:
                value = script.getField('VALUE');
                if (mediaPipeUtils.isInitialized) {
                  _context3.next = 1;
                  break;
                }
                _context3.next = 1;
                return mediaPipeUtils.initialize();
              case 1:
                if (value === 'show') {
                  mediaPipeUtils.changeDrawDetectedHand(true);
                } else {
                  mediaPipeUtils.changeDrawDetectedHand(false);
                }
                return _context3.abrupt("return", script.callReturn());
              case 2:
              case "end":
                return _context3.stop();
            }
          }, _callee3);
        }))();
      },
      wikiClass: 'ai_utilize_gesture'
    },
    check_detected_hand: {
      color: EntryStatic.colorSet.block["default"].AI_UTILIZE,
      outerLine: EntryStatic.colorSet.block.darken.AI_UTILIZE,
      skeleton: 'basic_boolean_field',
      statements: [],
      params: [],
      events: {},
      def: {
        type: 'check_detected_hand'
      },
      paramsKeyMap: {
        VALUE: 0
      },
      "class": 'hand',
      isNotFor: ['gestureRecognition'],
      func: function func(sprite, script) {
        return mediaPipeUtils.isPrevHandDetected;
      },
      wikiClass: 'ai_utilize_gesture'
    },
    count_detected_hand: {
      color: EntryStatic.colorSet.block["default"].AI_UTILIZE,
      outerLine: EntryStatic.colorSet.block.darken.AI_UTILIZE,
      skeleton: 'basic_string_field',
      statements: [],
      params: [],
      events: {},
      def: {
        type: 'count_detected_hand'
      },
      paramsKeyMap: {
        VALUE: 0
      },
      "class": 'hand',
      isNotFor: ['gestureRecognition'],
      func: function func(sprite, script) {
        return mediaPipeUtils.countDetectedHand;
      },
      wikiClass: 'ai_utilize_gesture'
    },
    locate_to_hand: {
      color: EntryStatic.colorSet.block["default"].AI_UTILIZE,
      outerLine: EntryStatic.colorSet.block.darken.AI_UTILIZE,
      skeleton: 'basic',
      statements: [],
      params: [params.getHandNumber(), params.getHandPoint(), params.getHandDetailPoint(), params.getCommonIndicator()],
      events: {},
      def: {
        type: 'locate_to_hand'
      },
      paramsKeyMap: {
        HAND: 0,
        HAND_POINT: 1,
        HAND_DETAIL_POINT: 2
      },
      "class": 'hand',
      isNotFor: ['gestureRecognition'],
      func: function func(sprite, script) {
        var hand = script.getField('HAND');
        var point = script.getField('HAND_POINT');
        var detail = script.getField('HAND_DETAIL_POINT');
        var handPoint = point + detail;
        var axis = mediaPipeUtils.getHandPointAxis(hand, handPoint);
        if (axis) {
          sprite.setX(axis.x);
          sprite.setY(axis.y);
          if (sprite.brush && !sprite.brush.stop) {
            sprite.brush.lineTo(axis.x, axis.y * -1);
          }
        }
        return script.callReturn();
      },
      wikiClass: 'ai_utilize_gesture'
    },
    locate_time_to_hand: {
      color: EntryStatic.colorSet.block["default"].AI_UTILIZE,
      outerLine: EntryStatic.colorSet.block.darken.AI_UTILIZE,
      skeleton: 'basic',
      statements: [],
      params: [{
        type: 'Block',
        accept: 'string',
        defaultType: 'number'
      }, params.getHandNumber(), params.getHandPoint(), params.getHandDetailPoint(), params.getCommonIndicator()],
      events: {},
      def: {
        params: [{
          type: 'number',
          params: ['2']
        }, null, null, null],
        type: 'locate_time_to_hand'
      },
      paramsKeyMap: {
        TIME: 0,
        HAND: 1,
        HAND_POINT: 2,
        HAND_DETAIL_POINT: 3
      },
      "class": 'hand',
      isNotFor: ['gestureRecognition'],
      func: function func(sprite, script) {
        if (!script.isStart) {
          var time = script.getNumberValue('TIME', script);
          var frameCount = Math.floor(time * Entry.FPS);
          var hand = script.getField('HAND', script);
          var point = script.getField('HAND_POINT', script);
          var detail = script.getField('HAND_DETAIL_POINT', script);
          var handPoint = point + detail;
          if (frameCount != 0) {
            var axis = mediaPipeUtils.getHandPointAxis(hand, handPoint);
            if (axis) {
              script.isStart = true;
              script.frameCount = frameCount;
              script.dX = (axis.x - sprite.getX()) / script.frameCount;
              script.dY = (axis.y - sprite.getY()) / script.frameCount;
            }
          } else {
            var _axis = mediaPipeUtils.getHandPointAxis(hand, handPoint);
            if (_axis) {
              sprite.setX(_axis.x);
              sprite.setY(_axis.y);
              if (sprite.brush && !sprite.brush.stop) {
                sprite.brush.lineTo(_axis.x, _axis.y * -1);
              }
            }
            return script.callReturn();
          }
        }
        if (script.frameCount != 0) {
          sprite.setX(sprite.getX() + script.dX);
          sprite.setY(sprite.getY() + script.dY);
          script.frameCount--;
          if (sprite.brush && !sprite.brush.stop) {
            sprite.brush.lineTo(sprite.getX(), sprite.getY() * -1);
          }
          return script;
        } else {
          delete script.isStart;
          delete script.frameCount;
          return script.callReturn();
        }
      },
      wikiClass: 'ai_utilize_gesture'
    },
    axis_detected_hand: {
      color: EntryStatic.colorSet.block["default"].AI_UTILIZE,
      outerLine: EntryStatic.colorSet.block.darken.AI_UTILIZE,
      skeleton: 'basic_string_field',
      statements: [],
      params: [_objectSpread(_objectSpread({}, params.getHandNumber()), {}, {
        fontSize: 10
      }), _objectSpread(_objectSpread({}, params.getHandPoint()), {}, {
        fontSize: 10
      }), _objectSpread(_objectSpread({}, params.getHandDetailPoint()), {}, {
        fontSize: 10
      }), _objectSpread(_objectSpread({}, params.getAxis()), {}, {
        fontSize: 10
      })],
      events: {},
      def: {
        params: [null, null, null, null],
        type: 'axis_detected_hand'
      },
      paramsKeyMap: {
        HAND: 0,
        HAND_POINT: 1,
        HAND_DETAIL_POINT: 2,
        AXIS: 3
      },
      "class": 'hand',
      isNotFor: ['gestureRecognition'],
      func: function func(sprite, script) {
        var hand = script.getField('HAND', script);
        var point = script.getField('HAND_POINT', script);
        var detail = script.getField('HAND_DETAIL_POINT', script);
        var axisName = script.getField('AXIS', script);
        var handPoint = point + detail;
        var axis = mediaPipeUtils.getHandPointAxis(hand, handPoint);
        if (axis) {
          return axis[axisName] || 0;
        }
        return 0;
      },
      wikiClass: 'ai_utilize_gesture'
    },
    is_which_hand: {
      color: EntryStatic.colorSet.block["default"].AI_UTILIZE,
      outerLine: EntryStatic.colorSet.block.darken.AI_UTILIZE,
      skeleton: 'basic_boolean_field',
      statements: [],
      params: [_objectSpread(_objectSpread({}, params.getHandNumber()), {}, {
        fontSize: 10
      }), _objectSpread(_objectSpread({}, params.getHand()), {}, {
        fontSize: 10
      })],
      events: {},
      def: {
        params: [null, null],
        type: 'is_which_hand'
      },
      paramsKeyMap: {
        HAND_NUM: 0,
        HAND: 1
      },
      "class": 'hand',
      isNotFor: ['gestureRecognition'],
      func: function func(sprite, script) {
        var handNum = script.getField('HAND_NUM', script);
        var hand = script.getField('HAND', script);
        var handedness = mediaPipeUtils.getHandedness(handNum);
        if (!handedness) {
          return false;
        }
        return handedness.categoryName === hand;
      },
      wikiClass: 'ai_utilize_gesture'
    },
    get_which_hand: {
      color: EntryStatic.colorSet.block["default"].AI_UTILIZE,
      outerLine: EntryStatic.colorSet.block.darken.AI_UTILIZE,
      skeleton: 'basic_string_field',
      statements: [],
      params: [_objectSpread(_objectSpread({}, params.getHandNumber()), {}, {
        fontSize: 10
      })],
      events: {},
      def: {
        params: [null, null],
        type: 'get_which_hand'
      },
      paramsKeyMap: {
        HAND_NUM: 0
      },
      "class": 'hand',
      isNotFor: ['gestureRecognition'],
      func: function func(sprite, script) {
        var handNum = script.getField('HAND_NUM', script);
        var handedness = mediaPipeUtils.getHandedness(handNum);
        if (!handedness) {
          return 'null';
        } else if (handedness.categoryName === 'Left') {
          return Lang.Blocks.right_hand;
        } else {
          return Lang.Blocks.left_hand;
        }
      },
      wikiClass: 'ai_utilize_gesture'
    },
    is_which_gesture: {
      color: EntryStatic.colorSet.block["default"].AI_UTILIZE,
      outerLine: EntryStatic.colorSet.block.darken.AI_UTILIZE,
      skeleton: 'basic_boolean_field',
      statements: [],
      params: [_objectSpread(_objectSpread({}, params.getHandNumber()), {}, {
        fontSize: 10
      }), _objectSpread(_objectSpread({}, params.getGesture()), {}, {
        fontSize: 10
      })],
      events: {},
      def: {
        params: [null, null],
        type: 'is_which_gesture'
      },
      paramsKeyMap: {
        HAND_NUM: 0,
        GESTURE: 1
      },
      "class": 'hand',
      isNotFor: ['gestureRecognition'],
      func: function func(sprite, script) {
        var handNum = script.getField('HAND_NUM', script);
        var gestureName = script.getField('GESTURE', script);
        var gesture = mediaPipeUtils.getGesture(handNum);
        if (!gesture) {
          return false;
        }
        return gesture.categoryName === gestureName;
      },
      wikiClass: 'ai_utilize_gesture'
    },
    get_which_gesture: {
      color: EntryStatic.colorSet.block["default"].AI_UTILIZE,
      outerLine: EntryStatic.colorSet.block.darken.AI_UTILIZE,
      skeleton: 'basic_string_field',
      statements: [],
      params: [_objectSpread(_objectSpread({}, params.getHandNumber()), {}, {
        fontSize: 10
      })],
      events: {},
      def: {
        params: [null, null],
        type: 'get_which_gesture'
      },
      paramsKeyMap: {
        HAND_NUM: 0
      },
      "class": 'hand',
      isNotFor: ['gestureRecognition'],
      func: function func(sprite, script) {
        var handNum = script.getField('HAND_NUM', script);
        var gesture = mediaPipeUtils.getGesture(handNum);
        if (!gesture) {
          return 'null';
        }
        return Lang.gesture_list[gesture.categoryName.toLowerCase()] || Lang.Blocks.unknown;
      },
      wikiClass: 'ai_utilize_gesture'
    }
  };
};